module.exports = __webpack_public_path__ + "static/media/flo_vorstellung0800.6775238a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/standalone/flo_vorstellung0800.jpg
// module id = 173
// module chunks = 0